import Vue from 'vue'

export default Vue.extend({
  template: '<g-data-status :title-level="titleLevel" :title="title" :text="text"/>',
  data () {
    return {
      titleLevel: 'normal',
      title: '',
      text: 'No results'
    }
  },
  watch: {
    'params.exception': {
      handler (value) {
      },
      immediate: true
    }
  }
})



// WEBPACK FOOTER //
// ./src/pages/mixin/components/DataNoRow.js